(() => {
  const tagName = 'c-why-3pm-graphic';
  if (customElements.get(tagName)) return;

  class Why3pmGraphic extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.toggleAttribute('data-motion-ready', true);
      document.addEventListener('visibilitychange', () => this.updateRunning(), {
        signal: this.controller.signal,
      });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.toggleAttribute('data-visible', entry.isIntersecting);
          });
          this.updateRunning();
        });
        this.observer.observe(this);
      } else {
        this.toggleAttribute('data-visible', true);
        this.updateRunning();
      }
    }

    updateRunning() {
      this.toggleAttribute('data-running', this.hasAttribute('data-visible') && !document.hidden);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.removeAttribute('data-motion-ready');
      this.removeAttribute('data-visible');
      this.removeAttribute('data-running');
    }
  }

  customElements.define(tagName, Why3pmGraphic);
})();
